import { useUserState } from "../store";
import { RoleName } from "../modules/common/enums/RoleName";

/**
 * Returns whether the current user is allowed to modify content
 * (i.e. has an ADMIN or EDITOR role). Viewers get read-only access:
 * they can see and export short videos, but cannot generate or edit them.
 *
 * Defaults to `false` (no edit access) when the user or roles are missing.
 */
export function useCanEdit(): boolean {
  const { user } = useUserState();

  if (!user || !Array.isArray(user.roles)) {
    return false;
  }

  return user.roles.some(
    (role) => role === RoleName.ADMIN || role === RoleName.EDITOR,
  );
}
